type UniqueById = string | number | undefined;

export const uniqueById = <T extends { id: UniqueById }>(items: Array<T | undefined | null>): T[] => {
    const byId = new Map<UniqueById, T>();
    for (const item of items) {
        if (!item) {
            continue;
        }
        if (!byId.has(item.id)) {
            byId.set(item.id, item);
        }
    }
    return Array.from(byId.values());
};
